Array.prototype.removeAt = function (index) {
    this.splice(index, 1);
    return this
}
Array.prototype.remove = function (item) {
    if(typeof item=="function"){
        item = this.filter(item)[0]
    }
    const index = this.indexOf(item)
    this.splice(index, 1);
    return this
}
